

import __layout_0 from '/C:/Users/Usuario/Documents/GitHub/catona/src/layouts/default.vue'
export const layouts = {
'blank': () => import('/C:/Users/Usuario/Documents/GitHub/catona/src/layouts/blank.vue'),
'default': __layout_0,
'components/DefaultLayoutWithHorizontalNav': () => import('/C:/Users/Usuario/Documents/GitHub/catona/src/layouts/components/DefaultLayoutWithHorizontalNav.vue'),
'components/DefaultLayoutWithVerticalNav': () => import('/C:/Users/Usuario/Documents/GitHub/catona/src/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/Footer': () => import('/C:/Users/Usuario/Documents/GitHub/catona/src/layouts/components/Footer.vue'),
'components/NavBarNotifications': () => import('/C:/Users/Usuario/Documents/GitHub/catona/src/layouts/components/NavBarNotifications.vue'),
'components/NavbarShortcuts': () => import('/C:/Users/Usuario/Documents/GitHub/catona/src/layouts/components/NavbarShortcuts.vue'),
'components/NavbarThemeSwitcher': () => import('/C:/Users/Usuario/Documents/GitHub/catona/src/layouts/components/NavbarThemeSwitcher.vue'),
'components/NavSearchBar': () => import('/C:/Users/Usuario/Documents/GitHub/catona/src/layouts/components/NavSearchBar.vue'),
'components/UserProfile': () => import('/C:/Users/Usuario/Documents/GitHub/catona/src/layouts/components/UserProfile.vue'),
}
export const createGetRoutes = (router, withLayout = false) => {
  const routes = router.getRoutes()
  if (withLayout) {
      return routes
  }
  return () => routes.filter(route => !route.meta.isLayout)
}

export function setupLayouts(routes) {
  function deepSetupLayout(routes, top = true) {
    return routes.map(route => {
      if (route.children?.length > 0) {
        route.children = deepSetupLayout(route.children, false)
      }
      
      if (top && route.meta?.layout !== false) {
        return { 
          path: route.path,
          component: layouts[route.meta?.layout || 'default'],
          children: [ {...route, path: ''} ],
          meta: {
            isLayout: true
          }
        }
      }

      if (route.meta?.layout) {
        return { 
          path: route.path,
          component: layouts[route.meta?.layout],
          children: [ {...route, path: ''} ],
          meta: {
            isLayout: true
          }
        }
      }

      return route
    })
  }

    return deepSetupLayout(routes)

}
